import React, {FC} from 'react';

import classNames from 'classnames';

import {CheckoutItemType} from 'desktop/types/checkoutItemsType';

import style from './quantitySelector.scss';

type PropsType = {
    item: CheckoutItemType;
    isRebatePassed?: boolean;
};

/**
 * QuantitySelector component allows users to view the quantity of an item.
 * @returns {JSX.Element} The rendered QuantitySelector component.
 */
export const QuantitySelector: FC<PropsType> = ({isRebatePassed, item}) => {
    const {prescription, subscription} = item;

    return (
        <p
            className={classNames(style.quantity, {
                [style.withRebate]: isRebatePassed,
                [style.withSubscription]: subscription?.subscriptionMode,
            })}
            aria-label="quantity"
        >
            Qty:
            <span
                aria-label="unClickable-text-for-popup"
                className={classNames(style.qtyEditButton, style.unClickable)}
            >
                Right {prescription?.od.boxes} | Left {prescription?.os.boxes}
            </span>
        </p>
    );
};
